import React from 'react';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { COLOR } from '@src/styles/color';
import { StyledV2WarningBox } from './index.style';

const V2WarningBox = () => {
  const { t } = useTranslation();
  return (
    <StyledV2WarningBox>
      <WarningRoundedIcon className="warning-icon" />
      <Typography variant="body-14-regular" color={COLOR.darkGray}>
        {t('packageWarningDescription')}
      </Typography>
    </StyledV2WarningBox>
  );
};

export default V2WarningBox;
